import { render, staticRenderFns } from "./FormCreateResearchPage1.vue?vue&type=template&id=9a52c158&"
import script from "./FormCreateResearchPage1.vue?vue&type=script&lang=js&"
export * from "./FormCreateResearchPage1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports